import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { RfqCacheService } from '../../../dashboard/rfq-cache.service';
import {
  AbstractControl,
  FormBuilder,
  FormArray,
  FormControl,
  FormGroup,
  NgForm,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SearchService } from 'src/app/views/search/search/search.service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { Page } from 'src/app/shared/models/page';
import {
  aboutDataType,
  AutoCompleteDataType,
  AutoCompleteSupplierProduct,
  Currency,
  quoteAttachmentType,
  quoteDeclineReasonType,
  incoterms,
  offeredQuality,
  portData,
  supplierBranchData,
  Vessel,
} from 'src/app/shared/models/settings.model';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { CookieService } from 'ngx-cookie-service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
// import { SupplierService } from '../../supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService } from '../../../dashboard/supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService as ss } from 'src/app/views/settings/suppliers/supplier.service';
import { Supplier } from 'src/app/shared/models/supplier.model';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { QuoteService } from '../../../dashboard/quote/quote.service';
import { RfqGenerateFormService } from '../../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuidv4 } from 'uuid';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BuyerService } from 'src/app/views/settings/buyers/buyer.service';
import { AttachmentTypes } from 'src/app/shared/common/Enums';
import { MatRadioChange } from '@angular/material/radio';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { PurchaseOrderService } from '../purchase-order.service';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { UserManagementService } from 'src/app/views/userManagement/userManagement.service';

interface Attachment {
  name: string;
  systemName: string;
  fileKey: string;
  s3_path: string;
}

interface Countries {
  name: string;
  code: string;
  dialcode: string;
  currency: string;
  flag: string;
}

interface Location {
  locationId: number;
  locationName: string;
  code: string;
}

interface Incoterm {
  incotermId: number;
  incotermCode: string;
  userId: number;
  locationDetails: Location[];
}

@Component({
  selector: 'app-purchase-order-approval-details',
  templateUrl: './purchase-order-approval-details.component.html',
  styleUrls: ['./purchase-order-approval-details.component.css'],
})
export class PurchaseOrderApprovalDetailsComponent implements OnInit {
  @ViewChild('table') table!: DatatableComponent;
  @ViewChild('pdfContent') contentToPrint!: ElementRef<HTMLDivElement>;
  rfqId!: number;
  quoteId!: number;
  purchaseOrderId!: number;
  isSaved: boolean = false;
  currentTab: string = 'approval-details';
  tabEnabled: boolean = false;
  supplierId!: any;

  approvalList: any[] = [];
  

  tabs: any[] = [
    // {
    //   index: 0,
    //   label: 'LINE ITEMS',
    //   icon: 'directions_boat',
    //   route: 'line-items',
    // },
    // {
    //   index: 1,
    //   label: 'HEADER DETAILS',
    //   icon: 'looks',
    //   route: 'header',
    // },
    // {
    //   index: 2,
    //   label: 'PAYMENT TERMS',
    //   icon: 'location_searching',
    //   route: 'payment-terms',
    // },
    {
      index: 3,
      label: 'PURCHASE ORDER DETAILS',
      icon: 'location_searching',
      route: 'purchase-order-details',
    },
    {
      index: 4,
      label: 'APPROVAL DETAILS',
      icon: 'location_searching',
      route: 'approval-details',
    },
  ];
 

  constructor(
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private supplierService: SupplierService,
    private ss: ss,
    public dialog: MatDialog,
    private ls: LocalStoreService,
    private quoteService: QuoteService,
    private RfqGenerateFormService: RfqGenerateFormService,
    private cookieService: CookieService,
    private webApiService: WebApiService,
    private awsSdkService: AwsSdkService,
    private CookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private purchaseOrderService: PurchaseOrderService,
    private userManagementService: UserManagementService
  ) {

  }

  async ngOnInit() {
    this.fullLoaderService.showLoader();

    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (
        params['rfqId'] != '' &&
        params['quoteId'] != '' &&
        params['purchaseOrderId'] != ' '
      ) {
        this.rfqId = params['rfqId'];
        this.quoteId = params['quoteId'];
        this.purchaseOrderId = params['purchaseOrderId'];
        try {
          await this.fetchPurchaseOrderApprovalDetailsByPoId();
        } finally {
          
          this.fullLoaderService.hideLoader();
        }
      } else {
        
        this.fullLoaderService.hideLoader();
      }
    });

  }

async fetchPurchaseOrderApprovalDetailsByPoId(){
    try{
        let params = {
            purchaseOrderId:Number(this.purchaseOrderId)
        }
        const result = await this.purchaseOrderService.fetchPurchaseOrderApprovalDetailsByPoId(params);
        console.log("approval Details fetched by PO Id",result);

         if (result?.data) {
            // Convert to array
            const approvals = Object.values(result.data);

            // Sort so that item with isApprover = 1 always appears first
            this.approvalList = approvals.sort((a: any, b: any) => b.isApprover - a.isApprover);
          }

    }catch(error){
        console.log("error",error);
    }
}

async selectMatTabLink(tabItem: any) {
    if (tabItem.route == 'approval-details') {
      this.activatedRoute.queryParams.subscribe(async (params) => {
        if (
          params['rfqId'] != '' &&
          params['quoteId'] != '' &&
          params['purchaseOrderId'] != ''
        ) {
          this.rfqId = params['rfqId'];
          this.quoteId = params['quoteId'];
          this.purchaseOrderId = params['purchaseOrderId'];

          this.router.navigate(['operations', 'createOrder', 'approval-details'], {
            queryParams: {
              rfqId: this.rfqId,
              quoteId: this.quoteId,
              purchaseOrderId: this.purchaseOrderId,
            },
          });
        }
      });
    }else if (tabItem.route == 'purchase-order-details') {
      this.activatedRoute.queryParams.subscribe(async (params) => {
        if (
          params['rfqId'] != '' &&
          params['quoteId'] != '' &&
          params['purchaseOrderId'] != ''
        ) {
          this.rfqId = params['rfqId'];
          this.quoteId = params['quoteId'];
          this.purchaseOrderId = params['purchaseOrderId'];

          this.router.navigate(['operations', 'createOrder', 'purchase-order-details'], {
            queryParams: {
              rfqId: this.rfqId,
              quoteId: this.quoteId,
              purchaseOrderId: this.purchaseOrderId,
            },
          });
        }
      });
    }
  }

close(){
    this.router.navigate(['/operations/purchase-order-approval-list'], {});
}


onApprove(approver: any) {
  console.log('Approve clicked', approver);
  // Implement API call or dialog
}

onReject(approver: any) {
  console.log('Reject clicked', approver);
  // Implement API call or dialog
}

onAddComment(approver: any) {
  console.log('Add Comment clicked', approver);
  // Open comment modal / text box
}

toggleActionBox(approver: any, type: 'approve' | 'reject') {
  // Close other popups first
  this.approvalList.forEach(a => (a.showActionBox = false));

  approver.showActionBox = true;
  approver.actionType = type;
  approver.tempComment = approver.tempComment || '';
}

cancelAction(approver: any) {
  approver.showActionBox = false;
  approver.tempComment = '';
}

async confirmApprove(approver: any) {
  this.fullLoaderService.showLoader();
  console.log('Approved:', approver.approverName, 'Comment:', approver.tempComment);
  approver.showActionBox = false;
  
  const params = {
    purchaseOrderId: this.purchaseOrderId,
    comment: approver.tempComment,
    statusId: 1
  }
  const result = await this.purchaseOrderService.updatePurchaseOrderApprovalDetailsByApproverId(params);
  await this.fetchPurchaseOrderApprovalDetailsByPoId();
  this.snack.open(`Approved by ${approver.approverName}`, '', { duration: 2000 });
  this.fullLoaderService.hideLoader();
}

async confirmReject(approver: any) {
  this.fullLoaderService.showLoader();
  console.log('Rejected:', approver.approverName, 'Comment:', approver.tempComment);
  approver.showActionBox = false;
  
  const params = {
    purchaseOrderId: this.purchaseOrderId,
    comment: approver.tempComment,
    statusId: 2
  }
  const result = await this.purchaseOrderService.updatePurchaseOrderApprovalDetailsByApproverId(params);
  await this.fetchPurchaseOrderApprovalDetailsByPoId();
  this.snack.open(`Rejected by ${approver.approverName}`, '', { duration: 2000 });
  this.fullLoaderService.hideLoader();
}

async sendPO(){
  this.fullLoaderService.showLoader();
  const params = {
      section: 'buyerPOApprovalDetails',
      purchaseOrderStatus: 3,
      purchaseOrderTabId: 4,
      quoteId: this.quoteId,
      userId: Number(this.cookieService.get('userId')),
      purchaseOrderId: this.purchaseOrderId,
      rfqId: this.rfqId,
    };

    const result = await this.purchaseOrderService.updatePurchaseOrder(params);
    const payload ={
      purchaseOrderId: this.purchaseOrderId
    }
    await this.purchaseOrderService.fetchPurchaseOrderDetailsAndSendPO(payload);
    await this.fetchPurchaseOrderApprovalDetailsByPoId();
    this.fullLoaderService.hideLoader();
}


 
 


 
  
}
